import React, { useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../../ui/Breadcrumbs";
import useOrganizationEdit from "./useOrganizationEdit";
import DeleteConfirmationModal from "../../../ui/DeleteConfirmationModal";
import { makeStyles } from "@material-ui/core/styles";
import Progress from "../../../ui/Progress";
import TopBar from "./components/TopBar";
import Box from "../../../ui/Box";
import Tabs from "../../../ui/Tabs";
import OrganizationDrawer from "../../components/OrganizationDrawer";
import OrganizationsForm from "./components/OrganizationsForm";
import Files from "./components/Files";
import EducationalServices from "./components/EducationalServices";
import SpecialitiesWorldSkills from "./components/SpecialitiesWorldSkills";
import BankCredentials from "./components/BankCredentials";
import ProfileInfo from "./components/ProfileInfo";
import OrgStructure from "./components/OrgStructure";
import {useMediaQuery} from 'react-responsive';
import OrganizationAboutEdit from "./components/About";

const useStyles = makeStyles(() => ({
    pageRoot: {
        display: "flex",
        background: "#F6FBFF"
    },
    contentRoot: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        width: "100%"
    },
    topBar: {
        marginBottom: 10
    },
    caption: {
        color: "#778899",
        fontSize: 10,
        marginBottom: 16
    },
    files: {
        maxWidth: '774px',
        minWidth: '400px'
    },
    fileInput: {
        display: 'none'
    }
}));

const items = [
    {
        label: "Управление ООП",
        link: "#"
    },
    {
        label: "Ресурсы",
        link: "/work/app/manage/resources"
    },
    {
        label: "Организации",
        link: "/work/app/manage/resources/org"
    },
    {
        label: "База организаций",
        link: "/work/app/organization"
    }
];

const tabitems = [
  {number: 0, caption: "Основные сведения"},
  {number: 1, caption: "Образовательные услуги"},
  {number: 2, caption: "Учетные данные"},
  {number: 3, caption: "Реквизиты"},
  {number: 4, caption: "Орг. структура"},
  {number: 5, caption: "Описание"}
];

const OrganizationEdit = ({ match, history }) => {
    const { id } = match.params;
    const classes = useStyles();
    const {
        organizationData: {
            deleteModalOpen,
            organizationInfo,
            isUpdatingOrganization,
            //updatedLogo,
            isEdited,
            files
        },
        setOrganizationsData,
        getOrganization,
        updateOrganization,
        deleteOrganization,
        addOrganizationFiles,
        deleteOrganizationFile,
        setOrganizationLogo,
        updateOrganizationProfile
    } = useOrganizationEdit();

    const [isEditable, setIsEditable] = React.useState(false);

    let editIconRef = useRef();

    const returnBack = () => history.push("/work/app/organization");

    useEffect(() => {
        getOrganization(id);
    }, []);

    const handleLogoChangeClick = () => {
        if (editIconRef.current) {
            editIconRef.current.click();
        }
    };

    const handleLogoLoad = (e) => {
        if (e.target.files.length > 0) {
            let file = e.target.files[0];
            setOrganizationLogo(id, file, file.fileName);
        }
    };

    const isLarge = useMediaQuery({minWidth: 1440});
    const isSmall = useMediaQuery({maxWidth: 774});

    return (
        <div>
          <input ref={editIconRef} className={classes.fileInput}
                 onChange={handleLogoLoad}
                 accept="image/*" type="file"/>
            <DeleteConfirmationModal
                modalText="Удалить организацию?"
                open={deleteModalOpen}
                onConfirm={() => {
                    deleteOrganization(id);
                    returnBack();
                }}
                handleClose={() =>
                    setOrganizationsData({ deleteModalOpen: false })
                }
            />
            <Breadcrumbs items={items} />
            {organizationInfo ? (
                <div className={classes.pageRoot}>
                    <div className={classes.contentRoot}>
                        <div className={classes.topBar}>
                            <TopBar
                              onReload={() => getOrganization(id)}
                                returnBack={returnBack}
                                onUpdate={() => {
                                    updateOrganization(id, organizationInfo);
                                }}
                                isUpdating={isUpdatingOrganization}
                                openDeleteModal={() =>
                                    setOrganizationsData({
                                        deleteModalOpen: true
                                    })
                                }
                                selectLogo={handleLogoChangeClick}
                                disabled={!isEdited}
                                editmode={isEditable}
                                setEditMode={() => setIsEditable(true)}
                                setViewMode={() => setIsEditable(false)}
                            />
                        </div>
                        <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
                            <Box noMargin>
                                <OrganizationsForm
                                    editmode={isEditable}
                                    initialData={organizationInfo.main}
                                    disabled={organizationInfo.info.editable}
                                    onFormChange={main =>
                                        setOrganizationsData({
                                            organizationInfo: {
                                                ...organizationInfo,
                                                main
                                            }
                                        })
                                    }
                                />
                                <div className={classes.files}>
                                    <Files
                                        editmode={isEditable}
                                        addFiles={files =>
                                            addOrganizationFiles(id, files)
                                        }
                                        files={files}
                                        deleteOrg={deleteOrganizationFile}
                                    />
                                </div>
                            </Box>
                            <Box noMargin>
                                <EducationalServices
                                    editmode={isEditable}
                                    initialData={organizationInfo.services}
                                    disabled={organizationInfo.info.editable}
                                    onFormChange={services =>
                                        setOrganizationsData({
                                            organizationInfo: {
                                                ...organizationInfo,
                                                services
                                            }
                                        })
                                    }
                                />
                                <SpecialitiesWorldSkills
                                    editmode={isEditable}
                                    initialData={organizationInfo}
                                    disabled={organizationInfo.info.editable}
                                    onFormChange={data =>
                                        setOrganizationsData({
                                            organizationInfo: {
                                                ...organizationInfo,
                                                ...data
                                            }
                                        })
                                    }
                                />
                            </Box>
                            <Box noMargin>
                                <ProfileInfo
                                  orgId={id}
                                  profile={organizationInfo.profile}
                                  updateProfile={updateOrganizationProfile} />
                            </Box>
                            <Box noMargin>
                                <BankCredentials
                                    editmode={isEditable}
                                    initialData={organizationInfo.bank}
                                    disabled={organizationInfo.info.editable}
                                    onFormChange={bank =>
                                        setOrganizationsData({
                                            organizationInfo: {
                                                ...organizationInfo,
                                                bank
                                            }
                                        })
                                    }
                                />
                            </Box>
                            <Box noMargin>
                                <OrgStructure info={organizationInfo} />
                            </Box>
                          <Box noMargin>
                            <OrganizationAboutEdit disabled={false}
                                                   initialData={organizationInfo.about}
                                                   onFormChange={about =>
                                                     setOrganizationsData({
                                                       organizationInfo: {
                                                         ...organizationInfo,
                                                         about
                                                       }
                                                     })
                                                   }/>
                          </Box>
                        </Tabs>
                    </div>
                    {isLarge &&
                    <OrganizationDrawer organizationId={id} open hideLink />}
                </div>
            ) : (
                <Progress />
            )}
        </div>
    );
};

export default withRouter(OrganizationEdit);
